import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpService } from '@app/@core/services/http.service';
import { CommonUrlConfig } from '@app/@core/config/common-url.config';
import { RegistrationService } from '../registration.service';
import { AlertService } from '@core/services/alert.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';

@Component({
  standalone: false,
  selector: 'app-registration-expired',
  templateUrl: './registration-expired.component.html',
  styleUrls: ['./registration-expired.component.scss']
})
export class RegistrationExpiredComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  email: string = '';
  cdStatus: string = '';
  expired: boolean = false;
  newDate: Date;
  registeredData: any;
  purged: boolean = false;
  maskedEmail: string = '';
  toastMessage: any = [];
  showToast = false;
  toastType: 'success' | 'error' = 'success';
  toastTitle = '';
  toastMessageText = '';
  diffDays: number = 0;
  updated_date: any ;
  purgeWindowDays: number = 30;
  private toastTimer: any;

  constructor(private route: ActivatedRoute, private httpService: HttpService,
    private readonly registrationService: RegistrationService, private router: Router,
    private alertService: AlertService
  ) { }



  ngOnInit() {
    this.loadOtpValidationRules();
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        this.email = params['email'] || '';
        this.cdStatus = params['cd_status'] || '';
        this.maskedEmail = this.getMaskedEmail(this.email);
        if (this.email) {
          // Skip API calls if registration is already completed
          if (this.cdStatus !== 'completed') {
            this.checkRegistrationDate();
            this.getRegistrationDetails();
          }
        }
      });
    if(window.localStorage.getItem('toastMessages') !== null && window.localStorage.getItem('toastMessages') !== undefined){
      let strMsg = window.localStorage.getItem('toastMessages').toString();
      let msgObj = JSON.parse(strMsg);
      msgObj.forEach((message: any) => {
        if (message.key && message.value !== undefined) {
          this.toastMessage[message.key] = message.value;
        }
      });
      console.log(this.toastMessage);
    }else{
      this.httpService.get(API_ENDPOINTS.TOAST_MESSAGES)
        .pipe(take(1),takeUntil(this.destroy$))
        .subscribe({
          next: (response: any) => {
            response.data.forEach((message: any) => {
              if (message.key && message.value !== undefined) {
                this.toastMessage[message.key] = message.value;
              }
            });
          }
        });
    }
  }

    private loadOtpValidationRules() {
    this.registrationService.getBusinessRuleByKey('Registration', 'registration_purge_window')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.data?.intValue) {
            this.purgeWindowDays = response.data.data.intValue;
          }
        },
        error: (error) => {
          console.error('Error fetching registration purge window rule:', error);
        }
      });
    }


  getRegistrationDetails() {
    this.httpService.get(`${API_ENDPOINTS.GET_DETAILS}${this.email}`)
      .pipe(take(1),takeUntil(this.destroy$))
      .subscribe({
      next: (response: any) => {
        this.registeredData = response.data.data;
      }
    });
  }

  checkRegistrationDate(): void {
  this.httpService.get(`${CommonUrlConfig.EndPoint.registration.getRegisteredDate}?email=${this.email}`)
      .pipe(take(1),takeUntil(this.destroy$))
      .subscribe({
      next: (response: any) => {
        const createdDateStr = response.data?.data?.[0]?.created_date;
        const createdDate = createdDateStr ? new Date(createdDateStr).getTime() : NaN;
        const currentDate = Date.now();
        const diffTime = currentDate - createdDate;
        this.diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        this.purged = this.diffDays > this.purgeWindowDays;
    }
  });
  }


  newRequest() {
  this.showToastMessage();
  let input = {
    email: this.email,
    front_end_domain: environment.frontEndDomain,
    createdDate: this.registeredData.updated_date,
  };


  if (this.diffDays <= this.purgeWindowDays) {
    this.registrationService.newRegistrationDate(input)
    .pipe(take(1),takeUntil(this.destroy$))
    .subscribe({
      next: (response: any) => {
        if (response && response.status === 'success') {
          this.updated_date = response.data.updatedDate 
          this.emailSent();
        }
      },
    });
  } 
}


  emailSent() {
    let request = {
      first_name: this.registeredData.first_name,
      last_name: this.registeredData.last_name,
      email: this.registeredData.primary_email,
      primary_phone: this.registeredData.primary_phone,
      front_end_domain: environment.frontEndDomain,
      recovery_email: this.registeredData.recovery_email,
      createdDate:  this.updated_date
    };
    this.registrationService.completeRegistration(request)
    .pipe(take(1),takeUntil(this.destroy$))
    .subscribe({
      next: response => {
        if (response.status === true) {
          setTimeout(() => {
            this.router.navigate(['/login']);
          }, 15000);
        } 
      },
    });
  }
  


  getMaskedEmail(email: string): string {
    if (!email) return '';
    let firstChar = email.slice(0, 1);
    let domainIndexStart = email.lastIndexOf("@");
    let maskedEmail = email.slice(1, domainIndexStart - 1);
    maskedEmail = maskedEmail.replace(/./g, '*');
    let domainPlusPreviousChar = email.slice(domainIndexStart - 1, email.length);
    return firstChar.concat(maskedEmail).concat(domainPlusPreviousChar);
  }
  showToastMessage() {  
   this.toastTitle = '';
   this.toastMessageText = this.toastMessage['T0009'];
   this.toastType = 'success';
   this.showToast = true;
   if (this.toastTimer) {
    clearTimeout(this.toastTimer);
  }
    this.toastTimer = setTimeout(() => {
    this.showToast = false;
  }, 7000);
  
  setTimeout(() => {
    this.router.navigate(['/login']);
  }, 15000);
}

  closeToast() {
    this.showToast = false;
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  }

  navigateToLogin(): void {
    this.router.navigate(['/login']);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
